/** Phones get the mobile layout unless the person chose the desktop version on this device. */
import { usePref } from '../lib/prefs';

/**
 * A touch screen that is narrow (upright) or short (a phone held sideways, 1.6.4: an iPhone in landscape is about
 * 932 pt wide but only 430 pt tall). A tablet is neither. Only the routes into the app ask: a /m page never switches
 * to the desktop layout when the phone is turned.
 */
export const PHONE_QUERY = '(pointer: coarse) and (max-width: 760px), (pointer: coarse) and (max-height: 500px)';

export const isPhone = (matchMedia: ((q: string) => { matches: boolean }) | undefined = typeof window !== 'undefined' ? window.matchMedia?.bind(window) : undefined) => {
  try {
    return Boolean(matchMedia?.(PHONE_QUERY).matches);
  } catch {
    return false;
  }
};

export function useDesktopPreference(): [boolean, (v: boolean) => void] {
  return usePref<boolean>('mobile.desktop', false);
}
